import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';

export default class Period extends BaseModel {
  constructor({
    id,
    number,
    designation,
    active = true,
    beginDate = undefined,
    endDate = undefined,
    closed = false,
  }) {
    super(id, number, designation);
    this.active = active;
    this.beginDate = beginDate;
    this.endDate = endDate;
    this.closed = closed;
  }

  get fullDesignation() {
    return this.designation;
  }

  static get fkName() {
    return 'period_id';
  }
  static get apiRoute() {
    return 'period';
  }
  static get detailPageRoute() {
    return 'periodList';
  }
  static get listPageRoute() {
    return 'periodList';
  }
  get fkName() {
    return Period.fkName;
  }
  get apiRoute() {
    return Period.apiRoute;
  }
  get listPageRoute() {
    return Period.listPageRoute;
  }
  get detailPageRoute() {
    return Period.detailPageRoute;
  }

  static get joinAttrsKey() {
    return ['number', 'designation', 'beginDate', 'endDate'];
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(
      ['number', 'designation', 'beginDate', 'endDate'],
      [],
    );
  }

  static get bulkUpdateAttrs() {
    return {
      'hit-base.bulk-update.general-information': this.getAttributes([
        'beginDate',
        'endDate',
        'closed',
      ]),
    };
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE({}, {maxWidth: '1fr'}),
      this.DESIGNATION_ATTRIBUTE(),
      this.ACTIVE_ATTRIBUTE(),
      new AT.DateAttribute({
        name: 'beginDate',
        column: 'begin_date',
        tableProperties: {
          header: 'hit-app.common.begin-date',
          maxWidth: '1fr',
        },
      }),
      new AT.DateAttribute({
        name: 'endDate',
        column: 'end_date',
        tableProperties: {
          header: 'hit-app.common.end-date',
          maxWidth: '1fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'closed',
        tableProperties: {
          header: 'hit-app.common.closed',
        },
      }),
    ];
  }
}
